
import React, { useState, useEffect } from 'react';
import './App.css';
import styles from './styles'
import theme, { getCustomTheme } from './theme';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import { Box, Typography, TextField, FormControlLabel, Avatar, RadioGroup, Radio, Button, Link, LinearProgress, InputLabel, MenuItem, Select, FormControl } from '@material-ui/core';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import Calendar from './Calendar/Calendar';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { isValidPhoneNumber } from 'libphonenumber-js'
import MuiPhoneNumber from 'material-ui-phone-number';
import AppointmentServices from './services/appointmentServices';
import OtpServices from './services/otpServices';
import UserAccount from './services/userAccountServices';
import UtilityServices from './services/utilityServices';
import currencySymbols from './utils/currencySymbolMap';
import QueryBuilderOutlinedIcon from '@material-ui/icons/QueryBuilderOutlined';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';
import FirebaseDBObj from './services/firebaseRtDbServices';
import { useMediaQuery } from 'react-responsive';
import { DEFAULT_CURRENCY } from './utils/constants'
import qs from 'qs';
import moment from 'moment-timezone';
import { withStyles } from '@material-ui/styles';

function App(props) {

  const { useCase } = props
  const [meetingType, setMeetingType] = useState('online')
  const [accountId, setAccountId] = useState(props.coachID)
  const [subscriptionId, setSubscriptionId] = useState(props.subscriptionID)
  const [selectedSlot, setSelectedSlot] = useState()
  const [reason, setReason] = useState('')
  const [subMenu, setSubMenu] = useState(1)
  const [coachDetails, setCoachDetails] = useState()
  const [unavailableDates, setUnavailableDates] = useState([])
  const [staffList, setStaffList] = useState({})

  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isMobileForIframe = useMediaQuery({ maxWidth: 720 });

  const [isIframe, setIframe] = useState(false)

  const [expanded, setExpanded] = useState(useCase !== "embedd" ? false : true)

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [otp, setOtp] = useState('')
  const [clientCurrency, setClientCurency] = useState(DEFAULT_CURRENCY)

  const [listOfNoVerified, setListVerified] = useState([])
  const [isOtpRequested, setIsOtpRequested] = useState(false)
  const [isOtpVerified, setIsOtpVerified] = useState(false)

  const [errors, setErrors] = useState({})
  const [loginErrMsg, setErrMsg] = useState();
  const [requestId, setRequestId] = useState()

  const [isMiniScreen, setMiniScreen] = useState(false)

  const [calendarLink, setCalendarLink] = useState('')

  const [pricingList, setPricingList] = useState([])
  const [pricingListToShow, setPricingListToShow] = useState([])
  const [selectedPrice, setSelectedPrice] = useState()

  const [razorPayDetails, setRazorPayDetails] = useState()

  const [isLoading, setIsLoading] = useState(false)
  const [isHideRequired, setIsHideRequired] = useState(false)

  const [customTheme, setCustomTheme] = useState(null)

  const [userExistsflag, setUserExistsflag] = useState(false)

  const isMobileScreen = () => {
    if (isIframe)
      return isMobileForIframe
    return isMobile
  }

  const formatPhoneNumber = phonenumber => {
    let res = phonenumber.replace(/\s/g, '');
    res = res.replace(/[&\/\\#,()$~%.'":*?<>{}-]/g, '');
    return res;
  };

  const handlePriceChange = (item) => {
    setSelectedPrice(item);
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  }
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  }
  const handlePhoneNumberChange = (phoneNumber) => {
    setErrMsg('')
    if (listOfNoVerified.includes(phoneNumber) || (selectedPrice && selectedPrice.cost > 0)) {
      setIsOtpVerified(true)
    }
    else {
      setIsOtpVerified(false)
      setIsOtpRequested(false)
    }
    setPhone(phoneNumber);
  }
  const handleOtpChange = (event) => {
    setOtp(event.target.value)
  }

  const validateInputs = () => {
    const formattedNumber = formatPhoneNumber(phone)
    const error = {}
    if (!name)
      error.name = "Name is required"
    if (!email)
      error.email = "Email is required"
    if (!phone)
      error.phone = "Phone Number is required"
    if (!isValidPhoneNumber(formattedNumber))
      error.phone = "Invalid Phone Number"
    if (email && !email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/))
      errors.email = "Invalid Email"
    setErrors(error)
    return error
  }

  const handleChangeRadio = (event) => {
    setMeetingType(event.target.value);
  };

  const handleReasonChange = (event) => {
    setReason(event.target.value)
  }

  const handleContinue = () => {
    if (pricingList.length === 0)
      setSubMenu(2)
    else {
      const selectedPriceForSlot = getPricingForSlot()
      if (selectedPriceForSlot === 'no_price_found')
        setSubMenu(5)
      else if (selectedPriceForSlot !== false) {
        setSelectedPrice(selectedPriceForSlot)
        setIsOtpVerified(true)
        setSubMenu(2)
      }
    }
  }

  const handleBackFromPrice = () => {
    setSubMenu(1)
  }

  const handleContinueAfterPrice = () => {
    if (selectedPrice.cost > 0)
      setIsOtpVerified(true)
    else
      setIsOtpVerified(false)
    if (selectedPrice)
      setSubMenu(2)
  }

  const getPricingForSlot = () => {
    if (selectedSlot == null)
      return false
    const currency = clientCurrency ? clientCurrency : DEFAULT_CURRENCY
    const locationId = selectedSlot.location_id
    if (locationId == null)
      return false
    const pricingDetail = pricingList.find(x => x.locationId == locationId && x.currency == currency)
    if (pricingDetail == null) {
      const pricingForLocation = pricingList.filter(x => x.locationId == locationId)
      setPricingListToShow(pricingForLocation)
      return "no_price_found"
    }
    return pricingDetail
  }

  const getClientCurrency = () => {
    UtilityServices
      .getClientLocationAndCurrency()
      .then(res => {
        if ('currency' in res.data && res.data.currency != null)
          setClientCurency(res.data.currency)
      })
      .catch(err => {
        setClientCurency(DEFAULT_CURRENCY)
      })
  }

  const callBackFncSlotSuccess = () => {
    const googleCalendar = getGoogleCalendarLink()
    setCalendarLink(googleCalendar)
    setSubMenu(3)
  }

  const callBackFncSlotAlready = () => {
    setSubMenu(7)
  }
  const callBackFncTimeout = () => {
    setSubMenu(4)
  }

  const handleConfirm = () => {
    const errors = validateInputs();
    if (Object.keys(errors).length > 0)
      return
    if (!isOtpVerified)
      return
    const timeZone = moment.tz.guess()
    const resObj = {
      phone_number: formatPhoneNumber(phone),
      slot_id: selectedSlot.slotId,
      email: email,
      name: name,
      time_zone: timeZone
    }
    if (selectedPrice && selectedPrice.cost > 0) {
      resObj.paymentOptionId = selectedPrice.paymentOptionId
      setIsLoading(true)
      AppointmentServices.generateRazorPayOrderId(resObj)
        .then(res => {
          if (res.status === 200) {
            setRazorPayDetails(res.data.razorpay_details)
            const razorPayOptions = {
              key: res.data.razorpay_details.razorpay_api_key, // Enter the Key ID generated from the Dashboard
              amount: res.data.pricing_details.cost * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
              currency: res.data.pricing_details.currency,
              name: coachDetails.firstName,
              description: "Appointment with coach " + coachDetails.firstName,
              order_id: res.data.razorpay_details.razorPayOrderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
              handler: function (response) {
                FirebaseDBObj.onSlotSuccess(accountId, selectedSlot.slotId, formatPhoneNumber(phone), callBackFncSlotSuccess, callBackFncSlotAlready, callBackFncTimeout)
                setSubMenu(6)
              },
              prefill: {
                name: name,
                email: email,
                contact: formatPhoneNumber(phone)
              },
            }
            const razorPay = new window.Razorpay(razorPayOptions);
            setIsLoading(false)
            razorPay.open()
            razorPay.on('payment.failed', callBackFncTimeout);
          }
        })
        .catch(err => {
          setIsLoading(false)
          setRazorPayDetails()
          console.log(err)
          if (err.response.data.message.code === 'SLOTALREADYBOOKED') {
            setSubMenu(7)
          }
          else
            setSubMenu(4)
        })
    }
    else {
      if (selectedPrice)
        resObj.paymentOptionId = selectedPrice.paymentOptionId
      setIsLoading(true)
      AppointmentServices.bookSlot(resObj)
        .then(res => {
          if (res.status === 200) {
            setIsLoading(false)
            const googleCalendar = getGoogleCalendarLink()
            setCalendarLink(googleCalendar)
            setSubMenu(3)
          }
        })
        .catch(err => {
          setIsLoading(false)
          console.log(err)
          setSubMenu(4)
        })
    }
  }

  const handleBack = () => {
    // if (pricingList.length === 0)
    //   setSubMenu(1)
    // else {
    //   setSelectedPrice()
    //   setSubMenu(5)
    // }
    setSelectedPrice()
    setSubMenu(1)
  }

  const handleChangeStaff = (event) => {
    setAccountId(event.target.value)
  }

  const handleLauncherToggle = () => {
    setExpanded(!expanded)
  }

  const requestOtp = () => {
    const errors = validateInputs();
    if ("phone" in errors)
      return
    const reqOtpObj = {
      mobile_number: formatPhoneNumber(phone),
      app_name: "DPOD App"
    }
    setIsLoading(true)
    OtpServices.requestOtp(JSON.stringify(reqOtpObj))
      .then(res => {
        setIsLoading(false)
        if (res.status === 200) {
          if ("request_id" in res.data && res.data.request_id !== null) {
            setErrMsg()
            setRequestId(res.data.request_id)
            setIsOtpRequested(true)
          }
          else if ("errors" in res.data && "message" in res.data.errors && res.data.errors.message !== null) {
            setErrMsg(res.data.errors.message)
          }
          else if ("errors" in res.data && Array.isArray(res.data.errors) && res.data.errors[0] && "message" in res.data.errors[0] && res.data.errors[0].message !== null) {
            setErrMsg(res.data.errors[0].message)
          }
          else {
            setErrMsg("Some error occured")
          }
        }
      })
      .catch(err => {
        console.log(err)
        setIsLoading(false)
        setErrMsg(err.message);
      })
  }

  const resendOtp = () => {
    const reqBody = {
      request_id: requestId
    }
    setIsLoading(true)
    OtpServices
      .resendOtp(JSON.stringify(reqBody))
      .then(res => {
        setIsLoading(false)
        if (res.status === 200) {
          setErrMsg()
          if ('request_id' in res.data)
            setRequestId(res.data.request_id)
        }
        else {
          setErrMsg("some error occured");
        }
      })
      .catch(err => {
        setIsLoading(false)
        console.log(err)
        setErrMsg("some error occured");
      })
  }

  const validateOtp = () => {
    const reqBody = {
      request_id: requestId,
      totp: otp
    }
    setIsLoading(true)
    OtpServices
      .verifyOtp(JSON.stringify(reqBody))
      .then(res => {
        setIsLoading(false)
        if (res.status === 200) {
          if ("verification_status" in res.data && res.data.verification_status.toLowerCase().trim() === "success") {
            setIsOtpRequested(false)
            setIsOtpVerified(true)
            setErrMsg()
            let tempArr = [...listOfNoVerified]
            tempArr.push(phone)
            setListVerified(tempArr)
          }
          else if ("verification_status" in res.data && res.data.verification_status.toLowerCase().trim() === "error") {
            setErrMsg("Invalid OTP");
          }
          else if ("errors" in res.data && "message" in res.data.errors && res.data.errors.message !== null) {
            setErrMsg(res.data.errors.message)
          }
          else {
            setErrMsg();
          }
        }
        else {
          setErrMsg("some error occured");
        }
      })
      .catch(err => {
        setIsLoading(false)
        console.log(err)
        setErrMsg("some error occured");
      })
  }

  const bookAnother = () => {
    setSubMenu(1)
    setMeetingType('online')
    setSelectedSlot()
    setReason('')
    setName('')
    setPhone('')
    setEmail('')
    setIsOtpVerified(false)
    setIsOtpRequested(false)
  }

  const validateUserExists = (event) => {
    const formattedNumber = formatPhoneNumber(event.target.value)
    // if (formattedNumber.match(/^[+][1-9]\d{1}[1-9]\d{9}/)) {
    if (isValidPhoneNumber(formattedNumber)) {
      UserAccount.isConsumer(parseInt(formattedNumber))
        .then(res => {
          if (res.status === 200) {
            if (res.data === true)
              setUserExistsflag(true)
            else
              setUserExistsflag(false)
          }
          else {
            setUserExistsflag(false)
          }
        })
        .catch(err => {
          setUserExistsflag(false)
          console.log(err)
        })
    }
    else {
      setUserExistsflag(false)
    }
  }

  const fetchStaffList = (accountID, subscriptionID) => {
    UserAccount.getStaffList(accountID, subscriptionID)
      .then(res => {
        if (res.status === 200) {
          let filteredCoach = {}
          let isSelfAdded = false
          res.data.professional.forEach(staff => {
            if (staff.accountId === accountID) {
              isSelfAdded = true
              filteredCoach = {
                ...filteredCoach,
                [staff.accountId]: {
                  firstName: staff.staffDetails.firstName,
                  profilePicURL: staff.staffDetails.profilePicURL,
                  userInitials: staff.staffDetails.userInitials,
                  designation: staff.staffDetails.designation,
                  accountId: staff.accountId
                }
              }
            }
            else if (staff.default_consultation_plan_id != null) {
              filteredCoach = {
                ...filteredCoach,
                [staff.accountId]: {
                  firstName: staff.staffDetails.firstName,
                  profilePicURL: staff.staffDetails.profilePicURL,
                  userInitials: staff.staffDetails.userInitials,
                  designation: staff.staffDetails.designation,
                  accountId: staff.accountId
                }
              }
            }
          })
          if (filteredCoach === false) {
            res.data.non_professional.forEach(staff => {
              if (staff.accountId === accountID) {
                isSelfAdded = true
                filteredCoach = {
                  ...filteredCoach,
                  [staff.accountId]: {
                    firstName: staff.staffDetails.firstName,
                    profilePicURL: staff.staffDetails.profilePicURL,
                    userInitials: staff.staffDetails.userInitials,
                    designation: staff.staffDetails.designation,
                    accountId: staff.accountId
                  }
                }
              }
            })
          }
          setStaffList({ ...filteredCoach })
        }
      })
      .catch(err => {
        console.log("Error while fetch staffList API in homeLayout Page", err)
        setStaffList({})
      })
  }

  const computeCustomTheme = (themeJson) => {
    try {
      const themeObj = JSON.parse(themeJson)
      console.log(themeObj)
      const generatedTheme = getCustomTheme(themeObj)
      console.log(generatedTheme)
      setCustomTheme(generatedTheme)
    }
    catch (err) {
      console.log("error occured while creating cutom theme")
      console.log(err)
      setCustomTheme(null)
    }
  }

  useEffect(() => {
    getClientCurrency()
    if (props.coachID != null && props.subscriptionID != null) {
      fetchStaffList(props.coachID, props.subscriptionID)
      return
    }
    else if (props.coachID != null) {
      fetchStaffList(props.coachID, '')
      return
    }
    else if (props.subscriptionID != null) {
      fetchStaffList(props.subscriptionID, props.subscriptionID)
      return
    }
    const coachAccId = document.getElementById("coach-appointment-widget").getAttribute("coachId")
    const coachsubscriptionID = document.getElementById("coach-appointment-widget").getAttribute("subscriptionID")
    const hideCoachDetails = document.getElementById("coach-appointment-widget").getAttribute("hideCoachDetails")
    if (hideCoachDetails === true || hideCoachDetails === "true")
      setIsHideRequired(true)
    else
      setIsHideRequired(false)
    const themeJson = document.getElementById("coach-appointment-widget").getAttribute("themeJson")
    if (themeJson != null && themeJson != "")
      computeCustomTheme(themeJson)
    if (coachAccId && coachsubscriptionID) {
      setAccountId(coachAccId)
      setSubscriptionId(coachsubscriptionID)
      fetchStaffList(coachAccId, coachsubscriptionID)
      return
    }
    else if (coachAccId) {
      setAccountId(coachAccId)
      setSubscriptionId(null)
      fetchStaffList(coachAccId, '')
      return
    }
    else if (coachsubscriptionID) {
      setAccountId(null)
      setSubscriptionId(coachsubscriptionID)
      fetchStaffList(coachsubscriptionID, coachsubscriptionID)
      return
    }
    else {
      const queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true })
      console.log("yoyo", queryParams)
      if ("hideCoachDetails" in queryParams) {
        console.log("here")
        if (queryParams.hideCoachDetails === true || queryParams.hideCoachDetails === "true")
          setIsHideRequired(true)
        else
          setIsHideRequired(false)
      }
      if ("themeJson" in queryParams) {
        if (queryParams.themeJson != null && queryParams.themeJson != "") {
          const themeJSON = atob(queryParams.themeJson)
          computeCustomTheme(themeJSON)
        }
      }
      setIframe(true)
      if ("fullSize" in queryParams) {
        if (queryParams.fullSize === false || queryParams.fullSize === 'false')
          setMiniScreen(true)
      }
      if ("accountId" in queryParams && "subscriptionId" in queryParams) {
        setAccountId(queryParams.accountId)
        setSubscriptionId(queryParams.subscriptionId)
        fetchStaffList(queryParams.accountId, queryParams.subscriptionId)
        return
      }
      else if ("accountId" in queryParams) {
        setAccountId(queryParams.accountId)
        setSubscriptionId(null)
        fetchStaffList(queryParams.accountId, '')
        return
      }
      else if ("subscriptionId" in queryParams) {
        setAccountId(null)
        setSubscriptionId(queryParams.subscriptionId)
        fetchStaffList(queryParams.subscriptionId, queryParams.subscriptionId)
        return
      }
    }
  }, [expanded])

  useEffect(() => {
    if (accountId) {
      UserAccount.getCurrentUserDetails(accountId)
        .then(res => {
          setCoachDetails(res.data)
        })
        .catch(err => {
          console.log("Error while fetching coach Details")
          console.log(err)
        })
      AppointmentServices.getPricingForCoach(accountId)
        .then(res => {
          if (res.data.payment_required) {
            setPricingList([...res.data.pricings_available])
            setSelectedPrice()
          }
          else {
            setPricingList([])
            setSelectedPrice()
          }
        })
        .catch(err => {
          console.log("err--------------")
          console.log(err)
          // if(err.response.data.message.code !== 'PLANNOTAVL'){

          // }
          setPricingList([])
          setSelectedPrice()
        })
      AppointmentServices
        .getUnavailableDatesForCoach(accountId)
        .then(res => {
          setUnavailableDates(res.data.dates)
        })
        .catch(err => {
          console.log("Error while fetching unavailable dates", err)
          setUnavailableDates([])
        })
    }
  }, [accountId])

  const getGoogleCalendarLink = () => {
    const coach_name = coachDetails.firstName
    const utcStartDate = selectedSlot.date + " " + selectedSlot.start_time
    const formatted_start_date = moment.utc(utcStartDate).local().format("YYYYMMDD")
    const formatted_start_time = moment.utc(utcStartDate).local().format("HHmmss")
    const utcEndDate = selectedSlot.date + " " + selectedSlot.end_time
    const formatted_end_date = moment.utc(utcEndDate).local().format("YYYYMMDD")
    const formatted_end_time = moment.utc(utcEndDate).local().format("HHmmss")
    const link = `https://calendar.google.com/calendar/r/eventedit?text=Appointment+With+${coach_name}&dates=${formatted_start_date}T${formatted_start_time}/${formatted_end_date}T${formatted_end_time}`
    return link
  }

  const useStyles = makeStyles(styles(customTheme != null ? customTheme : theme));
  const classes = useStyles();

  return (
    <div
      id="rootWidget"
      style={
        isMiniScreen
          ?
          {
            transform: 'scale(0.75)',
            transformOrigin: 'bottom right',
          }
          :
          {

          }
      }
    >
      <ThemeProvider theme={customTheme != null ? customTheme : theme}>
        <Box className={useCase !== "embedd" ? classes.outerBox : classes.outerBoxEmbedd}>
          {
            expanded
              ?
              (
                {
                  1:
                    <Box className={isMobileScreen() ? classes.rootMobile : classes.root}>
                      {isLoading && <LinearProgress color="secondary" />}
                      <Box display="flex" justifyContent="center">
                        <Typography className={classes.titleFont}>Book an appointment</Typography>
                        {/* <CloseIcon onClick={handleLauncherToggle} /> */}
                      </Box>
                      {
                        subscriptionId != null && subscriptionId != ""
                          ?
                          <Box marginBottom="25px">
                            <FormControl variant="outlined" fullWidth>
                              {/* <Typography className={classes.subTitleFont}>Chose your location</Typography> */}
                              <InputLabel id="demo-simple-select-outlined-label">Whom do you like to meet?</InputLabel>
                              <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={accountId ?? ''}
                                renderValue={(value) =>
                                  staffList[value] != null
                                    ?
                                    <Box display="flex" alignItems="center">
                                      <Box key={"MenuItemBox" + staffList[value].accountId} display="flex" justifyContent="flex-start">
                                        {
                                          staffList[value].profilePicURL != null && staffList[value].profilePicURL != ''
                                            ?
                                            <Avatar className={classes.avatar} src={staffList[value].profilePicURL}></Avatar>
                                            :
                                            (
                                              staffList[value].userInitials != null && staffList[value].userInitials != ''
                                                ?
                                                <Avatar className={classes.avatar}>{staffList[value].userInitials}</Avatar>
                                                :
                                                <Avatar className={classes.avatar}></Avatar>
                                            )
                                        }
                                      </Box>
                                      <Box display="flex" flexDirection="column">
                                        <Typography noWrap className={classes.clientNameList}>
                                          {staffList[value].firstName}
                                        </Typography>
                                        {
                                          staffList[value].designation != null && staffList[value].designation != ""
                                            ?
                                            <Typography noWrap className={classes.clientDesignationText}>
                                              {staffList[value].designation}
                                            </Typography>
                                            :
                                            ''
                                        }
                                      </Box>
                                    </Box>
                                    :
                                    "Whom do you like to meet"
                                }
                                inputProps={props.isMiniScreen ? { autoWidth: true } : {}}
                                onChange={handleChangeStaff}
                                label="Whom do you like to meet"
                              >
                                {
                                  Object.values(staffList).map(stf =>
                                    <MenuItem key={"MenuItem" + stf.accountId} value={stf.accountId}>
                                      <Box key={"MenuItemBox" + stf.accountId} display="flex" justifyContent="flex-start">
                                        {
                                          stf.profilePicURL != null && stf.profilePicURL != ''
                                            ?
                                            <Avatar className={classes.avatar} src={stf.profilePicURL}></Avatar>
                                            :
                                            (
                                              stf.userInitials != null && stf.userInitials != ''
                                                ?
                                                <Avatar className={classes.avatar}>{stf.userInitials}</Avatar>
                                                :
                                                <Avatar className={classes.avatar}></Avatar>
                                            )
                                        }
                                      </Box>
                                      <Box display="flex" flexDirection="column">
                                        <Typography noWrap className={classes.clientNameList}>
                                          {stf.firstName}
                                        </Typography>
                                        {
                                          stf.designation != null && stf.designation != ""
                                            ?
                                            <Typography noWrap className={classes.clientDesignationText}>
                                              {stf.designation}
                                            </Typography>
                                            :
                                            ''
                                        }
                                      </Box>
                                    </MenuItem>
                                  )
                                }
                              </Select>
                            </FormControl>
                          </Box>
                          :
                          (
                            isHideRequired === false && accountId && staffList[accountId] != null
                              ?
                              <Box marginBottom="25px">
                                <Box display="flex" alignItems="center">
                                  <Box key={"MenuItemBox" + staffList[accountId].accountId} display="flex" justifyContent="flex-start">
                                    {
                                      staffList[accountId].profilePicURL != null && staffList[accountId].profilePicURL != ''
                                        ?
                                        <Avatar className={classes.avatar} src={staffList[accountId].profilePicURL}></Avatar>
                                        :
                                        (
                                          staffList[accountId].userInitials != null && staffList[accountId].userInitials != ''
                                            ?
                                            <Avatar className={classes.avatar}>{staffList[accountId].userInitials}</Avatar>
                                            :
                                            <Avatar className={classes.avatar}></Avatar>
                                        )
                                    }
                                  </Box>
                                  <Box display="flex" flexDirection="column">
                                    <Typography noWrap className={classes.clientNameList}>
                                      {staffList[accountId].firstName}
                                    </Typography>
                                    {
                                      staffList[accountId].designation != null && staffList[accountId].designation != ""
                                        ?
                                        <Typography noWrap className={classes.clientDesignationText}>
                                          {staffList[accountId].designation}
                                        </Typography>
                                        :
                                        ''
                                    }
                                  </Box>
                                </Box>
                              </Box>
                              :
                              ''
                          )
                      }

                      <Box marginBottom="25px">
                        <Typography className={classes.subTitleFont}>Choose the type of appointment</Typography>
                        <RadioGroup aria-label="gender" name="gender1" value={meetingType} onChange={handleChangeRadio}>
                          <Box className={classes.flexBox}>
                            <Box className={classes.radioBox}>
                              <FormControlLabel value="online" control={<Radio color='secondary' />} label="Online" />
                            </Box>
                            <Box className={classes.radioBox}>
                              <FormControlLabel value="inperson" control={<Radio color='secondary' />} label="In Person" />
                            </Box>
                          </Box>
                        </RadioGroup>
                      </Box>
                      <Typography className={classes.subTitleFont}>Select your preferred time and location</Typography>
                      <Box className={classes.calendarBox}>
                        <Calendar
                          accountId={accountId}
                          selectedSlot={selectedSlot}
                          setSelectedSlot={setSelectedSlot}
                          unavailableDates={unavailableDates}
                          meetingType={meetingType}
                          isLoading={isLoading}
                          setIsLoading={setIsLoading}
                          isMiniScreen={isMiniScreen}
                          isIframe={isIframe}
                        />
                      </Box>
                      <Box className={classes.paymentBox}>
                        <Box className={classes.paymentModes}>
                          <Typography className={classes.paymentText}>Select an available time slot to continue</Typography>
                        </Box>
                        <Box
                          className={meetingType && selectedSlot ? classes.confirmBtn : classes.confirmBtnDisabled}
                          // className={classes.confirmBtn}
                          onClick={handleContinue}
                        >
                          <Typography className={classes.btnText}>Continue</Typography>
                        </Box>
                      </Box>
                    </Box>,
                  3:
                    <Box className={isMobileScreen() ? classes.rootMobile : classes.root}>
                      {isLoading && <LinearProgress color="secondary" />}
                      <Box display="flex" flexDirection="column" alignItems="center" height="100%">
                        <Typography className={classes.succMsgNew}>Appointment Confirmed</Typography>
                        {
                          selectedPrice && selectedPrice.cost > 0
                            ?
                            <Box display="flex" flexDirection="column" alignItems="center">
                              <Typography className={classes.succMsgNewSubtitle}>Thank you, we have received your payment. </Typography>
                              <Typography className={classes.succMsg}>{currencySymbols[selectedPrice.currency]}&nbsp;{selectedPrice.cost}</Typography>
                            </Box>
                            :
                            ''
                        }
                        <Box className={classes.successMsgBox}>
                          {
                            coachDetails
                              ?

                              <Typography className={classes.succMsg2}>You appointment with&nbsp;{coachDetails.firstName}&nbsp;is confirmed</Typography>

                              :
                              ''
                          }
                          {
                            selectedSlot
                              ?
                              <Typography className={classes.succMsgTime}>{moment(selectedSlot.date).format("DD, MMM YY")} | {moment.utc(selectedSlot.date + " " + selectedSlot.start_time).local().format("h:mm a")} - {moment.utc(selectedSlot.date + " " + selectedSlot.end_time).local().format("h:mm a")}&nbsp;{moment().tz(moment.tz.guess()).format('z')}</Typography>
                              :
                              ''
                          }
                          <Typography className={classes.succMsg3}>Appointment details sent to your email address</Typography>
                          <Link
                            href={calendarLink}
                            target={"_blank"}
                            variant="body2"
                            className={classes.addtoCalendarText}
                          >
                            Add to your calendar
                          </Link>
                        </Box>
                      </Box>
                      <Box className={classes.paymentBox} marginTop="50px">
                        <Box
                          // className={reason && meetingType && selectedSlot ? classes.confirmBtn : classes.confirmBtnDisabled}
                          className={classes.confirmBtn}
                          onClick={bookAnother}
                        >
                          <Typography className={classes.btnText}>Done</Typography>
                        </Box>
                      </Box>
                    </Box>,
                  2:
                    <Box className={isMobileScreen() ? classes.rootMobile : classes.root}>
                      {isLoading && <LinearProgress color="secondary" />}
                      <Box width="100%">
                        <Box display="flex" justifyContent="center">
                          <Typography className={classes.titleFont}>Book an appointment</Typography>
                        </Box>
                        {
                          selectedSlot
                            ?
                            <Box display="flex">
                              <Typography display='inline' className={classes.succMsgTime}>{moment.utc(selectedSlot.date + " " + selectedSlot.start_time).local().format("ddd, MMM DD | h:mm a")}</Typography>
                              &nbsp;&nbsp;
                              <Typography display='inline' className={classes.succMsgTime}>{moment().tz(moment.tz.guess()).format('z')}</Typography>
                              &nbsp;&nbsp;
                              <Box onClick={handleBack} className={classes.modifyBox}>
                                <EditOutlinedIcon color="secondary" />
                                <Typography display='inline' className={classes.modifyText}>Modify</Typography>
                              </Box>
                            </Box>
                            :
                            ''
                        }
                        <Box marginBottom="15px">
                          <Typography className={classes.subTitleFont}>What should we call you?</Typography>
                          <TextField
                            id="outlined-basic"
                            label="Your full name"
                            className={classes.whiteBox}
                            error={errors.name}
                            helperText={errors.name ? errors.name : ''}
                            size="small"
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            onChange={handleNameChange}
                            value={name}
                          />
                        </Box>
                        <Box marginBottom="15px">
                          <Typography className={classes.subTitleFont}>What email address can we reach you at?</Typography>
                          <TextField
                            id="outlined-basic"
                            label="Your email address"
                            margin="dense"
                            className={classes.whiteBox}
                            error={errors.email}
                            helperText={errors.email ? errors.email : ''}
                            size="small"
                            type="email"
                            variant="outlined"
                            fullWidth
                            onChange={handleEmailChange}
                            value={email}
                          />
                        </Box>
                        <Box marginBottom="15px">
                          <Typography className={classes.subTitleFont}>What's the reason for your visit?</Typography>
                          <TextField
                            id="outlined-basic"
                            className={classes.whiteBox}
                            size="small"
                            variant="outlined"
                            fullWidth
                            multiline
                            rowsMax={4}
                            onChange={handleReasonChange}
                            value={reason}
                          />
                        </Box>
                        <Box>
                          <Typography className={classes.subTitleFont}>Your contact number</Typography>
                          <MuiPhoneNumber
                            defaultCountry="in"
                            variant="outlined"
                            className={classes.whiteBox}
                            error={errors.phone}
                            helperText={errors.phone ? errors.phone : ''}
                            fullWidth
                            margin="dense"
                            label="Your phone number"
                            id="phonenumber"
                            size="small"
                            name="phonenumber"
                            onChange={handlePhoneNumberChange}
                            value={phone}
                            onBlur={validateUserExists}
                          />

                        </Box>
                        {
                          userExistsflag ? <Typography className={classes.noteText}>This Phonenumber is already associated with a user. Existing Details will be used.</Typography> : ''
                        }
                        {
                          isOtpRequested && !isOtpVerified
                            ?
                            <Box marginBottom="15px">
                              <TextField
                                id="outlined-basic"
                                label="Enter OTP"
                                className={classes.whiteBox}
                                size="small"
                                margin="dense"
                                variant="outlined"
                                fullWidth
                                onChange={handleOtpChange}
                                value={otp}
                              />
                              <Button size="small" color="secondary" variant="outlined" onClick={validateOtp}>Validate OTP</Button>
                              <Typography className={classes.verifyText} onClick={resendOtp}>Resend OTP</Typography>
                            </Box>
                            :
                            <Box marginBottom="15px" height="50px">
                              {
                                !isOtpVerified
                                  ?
                                  <Typography className={classes.verifyText} onClick={requestOtp}>Click here to verify</Typography>
                                  :
                                  ''
                              }
                            </Box>
                        }
                        {
                          loginErrMsg ? <Typography className={classes.errMsg}>{loginErrMsg}</Typography> : ''
                        }
                      </Box>
                      <Box width="100%">
                        <Box className={classes.paymentBox}>

                          {/* <Box
                            // className={reason && meetingType && selectedSlot ? classes.confirmBtn : classes.confirmBtnDisabled}
                            className={classes.confirmBtn}
                            onClick={handleBack}
                          >
                            <Typography className={classes.btnText}>Back</Typography>
                          </Box> */}
                          <Box
                            className={reason && meetingType && selectedSlot && isOtpVerified ? classes.confirmBtnFull : classes.confirmBtnDisabled}
                            // className={classes.confirmBtn}
                            onClick={handleConfirm}
                          >
                            {
                              selectedPrice && selectedPrice.cost > 0
                                ?
                                <Typography className={classes.btnText}>Pay&nbsp;{currencySymbols[selectedPrice.currency]}&nbsp;{selectedPrice.cost}</Typography>
                                :
                                <Typography className={classes.btnText}>Continue</Typography>
                            }
                          </Box>
                        </Box>
                      </Box>
                    </Box>,
                  4:
                    <Box className={isMobileScreen() ? classes.rootMobile : classes.root}>
                      {isLoading && <LinearProgress color="secondary" />}
                      <Box display="flex" width="100%" justifyContent="center"><Typography className={classes.errMsg}>Something went wrong</Typography></Box>
                      <Box className={classes.successMsgBox}>
                        <Typography className={classes.succMsg3}>Any amount if deducted will be refunded to the original mode of payment.</Typography>
                      </Box>
                      <Box className={classes.paymentBox} marginTop="50px">
                        <Box
                          // className={reason && meetingType && selectedSlot ? classes.confirmBtn : classes.confirmBtnDisabled}
                          className={classes.confirmBtn}
                          onClick={bookAnother}
                        >
                          <Typography className={classes.btnText}>Try again</Typography>
                        </Box>
                      </Box>
                    </Box>,
                  6:
                    <Box className={isMobileScreen() ? classes.rootMobile : classes.root}>
                      {isLoading && <LinearProgress color="secondary" />}
                      <Typography className={classes.succMsg}>Waiting for Payment confirmation</Typography>
                      <Box className={classes.waitingBox}>
                        <QueryBuilderOutlinedIcon className={classes.waitingIcon} />
                      </Box>
                      <Box className={classes.paymentBox} marginTop="50px">
                        <Box
                          // className={reason && meetingType && selectedSlot ? classes.confirmBtn : classes.confirmBtnDisabled}
                          className={classes.confirmBtn}
                          onClick={bookAnother}
                        >
                          <Typography className={classes.btnText}>Try again</Typography>
                        </Box>
                      </Box>
                    </Box>,
                  7:
                    <Box className={isMobileScreen() ? classes.rootMobile : classes.root}>
                      {isLoading && <LinearProgress color="secondary" />}
                      <Typography className={classes.succMsg}>Requested slot is un-available, we will process your refund</Typography>
                      <Box className={classes.waitingBox}>
                        <ErrorOutlineOutlinedIcon className={classes.waitingIcon} />
                      </Box>
                      <Box className={classes.paymentBox} marginTop="50px">
                        <Box
                          // className={reason && meetingType && selectedSlot ? classes.confirmBtn : classes.confirmBtnDisabled}
                          className={classes.confirmBtn}
                          onClick={bookAnother}
                        >
                          <Typography className={classes.btnText}>Try again</Typography>
                        </Box>
                      </Box>
                    </Box>,
                  5:
                    <Box className={isMobileScreen() ? classes.rootMobile : classes.root}>
                      {isLoading && <LinearProgress color="secondary" />}
                      <Box display="flex" flexDirection="column" height="100%">
                        {
                          pricingListToShow.length == 0
                            ?
                            <Typography className={classes.succMsg}>No pricing is defined by coach for this location</Typography>
                            :
                            <Typography className={classes.succMsg}>Select your preferred pricing</Typography>
                        }
                        {
                          pricingListToShow.map(item =>
                            <Box className={classes.pricingBox} onClick={handlePriceChange.bind(this, item)}>
                              <Typography className={classes.priceText} display="inline">{currencySymbols[item.currency]}&nbsp;&nbsp;&nbsp;&nbsp;{item.cost}</Typography>
                              {
                                selectedPrice && item.paymentOptionId == selectedPrice.paymentOptionId
                                  ?
                                  <CheckCircleOutlineOutlinedIcon className={classes.pricingTickIcon} color="primary" />
                                  :
                                  ''
                              }
                            </Box>
                          )
                        }
                      </Box>
                      <Box width="100%">
                        <Box className={classes.paymentBox}>
                          <Box
                            // className={reason && meetingType && selectedSlot ? classes.confirmBtn : classes.confirmBtnDisabled}
                            className={classes.confirmBtn}
                            onClick={handleBackFromPrice}
                          >
                            <Typography className={classes.btnText}>Back</Typography>
                          </Box>
                          <Box
                            className={selectedSlot && selectedPrice ? classes.confirmBtn : classes.confirmBtnDisabled}
                            // className={classes.confirmBtn}
                            onClick={handleContinueAfterPrice}
                          >
                            <Typography className={classes.btnText}>Continue</Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Box>,
                }[subMenu]
              )
              :
              ''
          }
          {
            useCase !== "embedd"
              ?
              (
                props.hideButton === true || props.hideButton === 'true'
                  ?
                  < Box id="toggleAppointmentSwitch" onClick={handleLauncherToggle}>

                  </Box>
                  :
                  < Box id="toggleAppointmentSwitch" className={classes.launcherBox} onClick={handleLauncherToggle}>
                    <img className={classes.widgetLauncherIcon} src='https://d1mex3rrfmrlk1.cloudfront.net/86719e5a-eeea-43a5-b87f-c0e3a34f1295/2021-05-04/8e07d697-bf0d-4dd3-a914-1ecb8444ce3e/account_setting_images/dpod_logo_b_5xpng.png' />
                  </Box>
              )
              :
              ''
          }
        </Box>
      </ThemeProvider>
    </div >
  );
}

export default App;
